module.exports = __webpack_public_path__ + "static/media/icon_price_line.8ce59046.svg";